import { AttendanceAttention } from "@/components/attendances/attendance-attention";
import { AttendanceInsights } from "@/components/attendances/attendance-insights";
import { AttendancesChart } from "@/components/attendances/attendances-chart";
import { AttendancesTimeline } from "@/components/attendances/attendances-timeline";
import { useAuth } from "@/hooks/use-auth";
import { ContentBox } from "@msuite/ui/app-shell";
import { Panels } from "@msuite/ui/panels";
import { guardString } from "@msuite/utils/strings";
import { AttendancesHeader } from "./attendances-header";

export function Attendances() {
	/** Hooks */
	const auth = useAuth();

	/** Render */
	return (
		<ContentBox>
			<AttendancesHeader />
			<AttendanceAttention userId={guardString(auth.user?.id)} />
			<Panels>
				<Panels.Panel flex={1}>
					<AttendanceInsights userId={guardString(auth.user?.id)} />
					<AttendancesChart userId={guardString(auth.user?.id)} />
				</Panels.Panel>
				<Panels.Panel flex={2}>
					<AttendancesTimeline />
				</Panels.Panel>
			</Panels>
		</ContentBox>
	);
}
